<div #content class="sol-text-box-content">
  @if (markdown$(); as markdown) {
    <sol-markdown [text]="markdown" [features]="markdownFeatures$()" [linkTarget]="linkTarget$()" />
  } @else {
    {{ visibleText$() }}
  }
</div>
@if (showMoreVisible$()) {
  <div class="sol-text-box-toggle-container">
    <sol-button [type]="SolButtonType.link" text="sol-common.read-more" (click)="onToggle()" />
  </div>
}
@if (showLessVisible$()) {
  <div class="sol-text-box-toggle-container">
    <sol-button [type]="SolButtonType.link" text="sol-common.show-less" (click)="onToggle()" />
  </div>
}
